import styles from './index.module.css'

import React from 'react'

import mixpanel from '@disco/api/mixpanel'
import { DISCO_SITE_FROM_PUBLIC_INBOX_URL } from '@disco/constants/external-links'

import FooterLogo from 'pages/upload/footer-logo'

const UploadFooter = ({
  displayLogo = true,
}: {
  displayLogo?: boolean
}): React.ReactElement<'div'> => {
  return (
    <div>
      <div className={styles.uploadFooter}>
        {displayLogo && (
          <div className={styles.uploadFooterLogo}>
            <FooterLogo
              link={DISCO_SITE_FROM_PUBLIC_INBOX_URL}
              onClick={() =>
                mixpanel.sendPureEvent('Click DISCO logo', {
                  'UTM Source': 'disco_playlist',
                  'UTM Medium': 'public_inbox',
                })
              }
            />
          </div>
        )}
        <div className={styles.uploadFooterLinks}>
          <a
            className={styles.uploadFooterLink}
            href="https://disco.ac/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
          <a
            className={styles.uploadFooterLink}
            href="https://disco.ac/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  )
}

export default UploadFooter
